<template>
  <div class="max-w-xl space-y-lgSpace pt-xlSpace">
    <form class="grid grid-cols-1 gap-smSpace">
      <input-wrapper field="name" :form="form" :label-text="$t('product_category.fields.name')">
        <input type="text" v-model="form.name" :placeholder="$t('product_category.placeholders.name')" />
      </input-wrapper>

      <input-wrapper field="parent_id" :form="form" :label-text="$t('product_category.fields.parent')">
        <v-multi-select
          v-model="form.parent_id"
          search-url="/api/generic/product-categories?filter[active]=1"
          :placeholder="$t('product.placeholders.category')"
          :is-multiple="false"
          track-by="id"
          label="name"
          search-key="filter[name]"
        />
      </input-wrapper>

      <v-checkbox v-model="form.active" :label-text="$t('product_category.fields.active')"></v-checkbox>
      <v-checkbox v-model="form.public" :label-text="$t('product_category.fields.public')"></v-checkbox>
    </form>
    <v-footer :list-url="listUrl" :save="save"></v-footer>
  </div>
</template>
<style>
.vc-color-wrap {
  @apply ml-2;
}
</style>
<script>
import Form from "form-backend-validation";

export default {
  name: "CategoryEdit",
  components: {},
  props: {
    category: {
      type: Object,
      default: () => {
        return {};
      },
    },
    listUrl: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      form: new Form(
        {
          id: this.getFieldValue("id"),
          name: this.getFieldValue("name"),
          active: this.getFieldValue("active"),
          public: this.getFieldValue("public"),
          parent_id: this.getFieldValue("parent_id"),
        },
        { resetOnSuccess: false },
      ),
    };
  },

  mounted() {},

  methods: {
    getFieldValue(field, defaultValue = null) {
      if (this.category.hasOwnProperty(field)) {
        return this.category[field];
      }

      return defaultValue;
    },
    close() {},
    save() {
      if (this.category.hasOwnProperty("id")) {
        this.form
          .patch(`/api/admin/product-categories/${this.category.id}`)
          .then(({}) => {
            window.location = this.listUrl;
          })
          .catch(({ response }) => {
            this.bus.$emit("showNotification", {
              content: response.data.message,
              type: "error",
            });
          });

        return;
      }

      this.form
        .post(`/api/admin/product-categories`)
        .then(({}) => {
          window.location = this.listUrl;
        })
        .catch(({ response }) => {
          this.bus.$emit("showNotification", {
            content: response.data.message,
            type: "error",
          });
        });
    },
  },
};
</script>
